import { VideoPlayerElement } from '../../presets/video/player';
import { safeDefine } from '../../registration/safe-define';

safeDefine(VideoPlayerElement);
